import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { STATUS_LABELS } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { Plus, Film, ArrowRight } from "lucide-react";

const EMPTY = "https://images.unsplash.com/photo-1769693315521-98dd527b7725";

export default function CustomerDashboard() {
  const { user } = useAuth();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
        <div>
          <p className="text-sm uppercase tracking-[0.3em] text-gold mb-2">Merhaba {user?.name?.split(" ")[0]}</p>
          <h1 className="font-serif text-4xl lg:text-5xl">Projelerim</h1>
        </div>
        <Link to="/new" data-testid="new-idea-button">
          <Button className="bg-gold text-black hover:bg-gold-light rounded-md h-11 px-6">
            <Plus className="w-4 h-4 mr-2" /> Yeni Fikir
          </Button>
        </Link>
      </div>

      {loading ? (
        <div className="text-white/40 animate-pulse">Yükleniyor…</div>
      ) : projects.length === 0 ? (
        <div className="relative rounded-2xl overflow-hidden border border-white/5" data-testid="empty-state">
          <img src={EMPTY} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-black/70" />
          <div className="relative p-14 text-center max-w-lg mx-auto">
            <Film className="w-10 h-10 text-gold mx-auto mb-5" />
            <h2 className="font-serif text-3xl mb-3">İlk fikrini yaz</h2>
            <p className="text-white/60 mb-8">
              Kafandaki hikâyeyi anlat, yapay zeka senin için sinematik bir senaryo taslağı hazırlasın.
            </p>
            <Link to="/new">
              <Button className="bg-gold text-black hover:bg-gold-light rounded-md h-11 px-8">
                Fikrini Oluştur
              </Button>
            </Link>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="projects-grid">
          {projects.map((p) => (
            <Link
              key={p.id}
              to={`/project/${p.id}`}
              data-testid={`project-card-${p.id}`}
              className="group bg-[#0A0A0A] border border-white/5 rounded-xl p-6 hover:border-gold/30 hover:-translate-y-1 transition-all flex flex-col"
            >
              <div className="flex items-start justify-between mb-4">
                <StatusBadge status={p.status} />
                {p.price_total && <span className="text-gold text-sm">{p.price_total.toLocaleString("tr-TR")} ₺</span>}
              </div>
              <h3 className="font-serif text-2xl mb-2 leading-tight">{p.title}</h3>
              <p className="text-sm text-white/50 line-clamp-3 flex-1">{p.idea}</p>
              <div className="flex items-center text-gold text-sm mt-5 group-hover:gap-2 transition-all">
                Detaya git <ArrowRight className="w-4 h-4 ml-1" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
